// extracted by mini-css-extract-plugin
export var container = "_5k-0";
export var error = "_5k-9";
export var label = "_5k-5";
export var light = "_5k-6";
export var md = "_5k-3";
export var sm = "_5k-2";
export var thin = "_5k-8";
export var thinBold = "_5k-7";
export var vertical = "_5k-4";
export var xs = "_5k-1";